import styled from 'styled-components';

export const FileInfoCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 1rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.5rem;
	background-color: ${({ theme }) => theme.v3.colors.white[0]};
`;

export const InfoRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 0.5rem;
`;
